'use es6';

import { NEED_CREATE_AND_OWN_PERMISSION, NEED_EDIT_PERMISSION } from 'dashboard-lib/private/action-problem-solution/problems/permission-problem';
import { lang } from 'dashboard-lib/private/js-util';
import FormattedReactMessage from 'I18n/components/FormattedReactMessage';
import { createFormattedActionName } from '../../actions/format-action';
import { createReactMessage } from './message';
import { jsx as _jsx } from "react/jsx-runtime";
const PROBLEM_MESSAGE_ROOT = 'reportingActions.common.problem';
const problemLang = lang(PROBLEM_MESSAGE_ROOT);
const needPermissionMessage = problemLang('NEED_PERMISSION');
export const NeedCreateAndOwnPermissionMessage = action => {
  const Name = createFormattedActionName(action);
  return createReactMessage(NEED_CREATE_AND_OWN_PERMISSION, () => /*#__PURE__*/_jsx(FormattedReactMessage, {
    message: needPermissionMessage,
    options: {
      action: /*#__PURE__*/_jsx(Name, {})
    }
  }));
};
export const NeedEditPermissionMessage = action => {
  const Name = createFormattedActionName(action);
  return createReactMessage(NEED_EDIT_PERMISSION, () => /*#__PURE__*/_jsx(FormattedReactMessage, {
    message: needPermissionMessage,
    options: {
      action: /*#__PURE__*/_jsx(Name, {})
    }
  }));
};